import { render, staticRenderFns } from "./payment-layout.component.vue?vue&type=template&id=27399c38"
import script from "./payment-layout.component.ts?vue&type=script&lang=ts&external"
export * from "./payment-layout.component.ts?vue&type=script&lang=ts&external"
import style0 from "./payment-layout.component.vue?vue&type=style&index=0&id=27399c38&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27399c38')) {
      api.createRecord('27399c38', component.options)
    } else {
      api.reload('27399c38', component.options)
    }
    module.hot.accept("./payment-layout.component.vue?vue&type=template&id=27399c38", function () {
      api.rerender('27399c38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/payment-layout/payment-layout.component.vue"
export default component.exports